<!--
 * @Description: 加盟商统计列表
-->
<template>
  <scroll-layout class="fleet-match-list">
    <template slot="header">
      <ykc-search
        ref="YkcSearch"
        :data="searchData"
        :searchForm="searchParams"
        @click="handleSearchConfirm"
        @clean="handleSearchClean"></ykc-search>
    </template>
    <div>
      <ykc-table
        ref="YkcTable"
        operateFixedType="right"
        :data="tableData"
        :title="tableTitle"
        :columns="tableColumns"
        :operateButtonsSplitCount="5"
        :operateButtons="tableOperateButtons">
        <template #headerButtons>
          <div class="table-header-button">
            <ykc-button v-rbac="'finance:settle:franchisee:apply'" type="plain" @click="apply">
              对账申请
            </ykc-button>
          </div>
        </template>
        <ykc-pagination
          align="right"
          slot="pagination"
          ref="YkcPagination"
          :total="pageInfo.total"
          :page-size.sync="pageInfo.size"
          :current-page.sync="pageInfo.current"
          @size-change="handlePaginationSizeChange"
          @current-change="handlePaginationCurrentChange"></ykc-pagination>
      </ykc-table>

      <ykc-operation-dialog
        title="选择站点"
        :before-confirm="stationSelect"
        confirm-btn-txt="确定"
        :show.sync="showStationSelect">
        <div slot="content">
          <ykc-form ref="stationForm" :model="stationForm" :rules="stationRules">
            <ykc-form-item label="站点" prop="stationId">
              <ykc-dropdown
                class="box-width box-width-left"
                placeholder="请选择站点"
                :data="stationListData"
                v-model="stationForm.stationId"></ykc-dropdown>
            </ykc-form-item>
          </ykc-form>
        </div>
      </ykc-operation-dialog>
      <ykc-operation-dialog
        title="审批结算单"
        :before-confirm="() => auditSettle(3)"
        :before-cancel="() => auditSettle(2)"
        confirm-btn-txt="审批通过"
        cancel-btn-txt="审批不通过"
        type="report"
        :show.sync="showAudit">
        <div slot="content">
          <ykc-form ref="auditForm" :model="auditForm" :rules="auditRules">
            <ykc-form-item label="审批备注" prop="auditRemark">
              <ykc-input
                v-model="auditForm.auditRemark"
                type="textarea"
                placeholder="备注"
                maxlength="500"></ykc-input>
            </ykc-form-item>
          </ykc-form>
        </div>
      </ykc-operation-dialog>
    </div>
  </scroll-layout>
</template>
<script>
  import YkcDialog from '@/components/ykc-ui/dialog';
  import YkcOperationDialog from '@/components/ykc-ui/operation-dialog';
  import { franchiseeSettleManage } from '@/service/apis';
  import { code, offlineExport } from '@/utils';

  export default {
    name: 'FranchiseeSettleList',
    components: {
      YkcOperationDialog,
    },
    data() {
      return {
        id: '',
        isEdit: false,
        showDrawer: false,
        showStationSelect: false,
        showAudit: false,
        drawerType: 'edit',
        stationId: '',
        dictionary: {},
        stationListData: [], // 电站列表
        franchiseeData: [], // 加盟商
        stationForm: {
          stationId: '',
        },
        auditForm: {
          auditRemark: '',
        },
        stationRules: {
          stationId: [{ required: true, message: '请选择站点', trigger: 'blur' }],
        },
        auditRules: {
          auditRemark: [{ required: true, message: '请输入审批备注', trigger: 'blur' }],
        },

        statusData: [
          { id: 1, name: '申请中' },
          { id: 2, name: '审批未通过' },
          { id: 3, name: '审批通过' },
          { id: 4, name: '已收款' },
        ],
        searchParams: {
          stationId: '',
          operatorId: '',
          startDate: '',
          endDate: '',
          status: '',
        },
        // 列表表格
        tableTitle: '结算单列表',
        tableData: [],
        tableOperateButtons: [
          {
            render: (h, data, { row }) =>
              code('finance:settle:franchisee:audit') && row.status === 1 ? (
                <ykc-button
                  type="text"
                  onClick={() => {
                    this.id = row.id;
                    this.showAudit = true;
                  }}>
                  审批结算单
                </ykc-button>
              ) : null,
          },
          {
            render: (h, data, { row }) =>
              code('finance:settle:franchisee:invoice') &&
              row.status === 3 &&
              row.invoiceStatus === 1 ? (
                <ykc-button
                  type="text"
                  onClick={() => {
                    this.invoice(row.id);
                  }}>
                  确认发票
                </ykc-button>
              ) : null,
          },
          {
            render: (h, data, { row }) =>
              code('finance:settle:franchisee:pay') &&
              row.status === 3 &&
              row.invoiceStatus === 2 ? (
                <ykc-button
                  type="text"
                  onClick={() => {
                    this.payment(row.id);
                  }}>
                  确认收款并提现
                </ykc-button>
              ) : null,
          },
          {
            enabled: () => true,
            render: (h, data, { row }) => (
              <ykc-button
                type="text"
                onClick={() => {
                  this.exportDetail(row);
                }}>
                导出订单明细
              </ykc-button>
            ),
          },
          {
            enabled: () => code('finance:settle:franchisee:detail'),
            render: (h, data, { row }) => (
              <ykc-button
                type="text"
                onClick={() => {
                  this.toDetail(row.id);
                }}>
                详情
              </ykc-button>
            ),
          },
        ], // 列表操作
        tableColumns: [
          { label: '结算单编号', prop: 'settleNo', minWidth: '200px' },
          {
            label: '结算时间',
            prop: 'settleTime',
            minWidth: '200px',
          },
          {
            label: '站点编码',
            prop: 'stationCode',
            minWidth: '200px',
          },
          { label: '站点名称', prop: 'stationName', minWidth: '200px' },
          {
            label: '经营模式',
            prop: 'tradeMode',
            minWidth: '200px',
            scopedSlots: {
              default: ({ row }) => {
                const title =
                  // eslint-disable-next-line no-nested-ternary
                  row.tradeMode === 1 ? '自营' : row.tradeMode === 2 ? '加盟商' : '-';
                return title;
              },
            },
          },
          { label: '加盟商名称', prop: 'operatorName', minWidth: '200px' },

          { label: '平台服务费抽成金额', prop: 'serviceFeeSharingAmount', minWidth: '200px' },
          { label: '平台服务费抽成方式', prop: 'serviceWayFeeStr', minWidth: '200px' },
          {
            label: '取电方式',
            prop: 'eleWay',
            minWidth: '200px',
            scopedSlots: {
              default: ({ row }) => {
                if (row.eleWay === 3) {
                  return '加盟商取电';
                }
                return '-';
              },
            },
          },
          { label: '结算总电量', prop: 'settleTotalEleCap', minWidth: '200px' },
          { label: '电费金额', prop: 'settleTotalPowerFee', minWidth: '200px' },
          { label: '实付金额', prop: 'userActualIncome', minWidth: '200px' },
          { label: '总结算金额', prop: 'settleTotalAmount', minWidth: '200px' },
          {
            label: '审批状态',
            prop: 'status',
            minWidth: '200px',
            scopedSlots: {
              default: ({ row }) => {
                if (row.status === 1) {
                  return '申请中';
                }
                if (row.status === 2) {
                  return '审批未通过';
                }
                if (row.status === 3) {
                  return '审批通过';
                }
                if (row.status === 4) {
                  return '已收款';
                }
                return '-';
              },
            },
          },
          {
            label: '发票状态',
            prop: 'invoiceStatus',
            minWidth: '200px',
            scopedSlots: {
              default: ({ row }) => {
                if (row.invoiceStatus === 1) {
                  return '待确认';
                }
                if (row.invoiceStatus === 2) {
                  return '已确认';
                }
                return '-';
              },
            },
          },
          { label: '收款日期', prop: 'collectionDate', minWidth: '200px' },
          {
            label: '备注',
            prop: 'remark',
            minWidth: '200px',
            scopedSlots: {
              default: ({ row }) => (row.status === 1 ? row.remark : row.auditRemark),
            },
          },
          { label: '创建人', prop: 'createdBy', minWidth: '200px' },
          { label: '创建时间', prop: 'createdTime', minWidth: '200px' },
        ],
        pageInfo: {
          total: 0,
          current: 1,
          size: 10,
        },
      };
    },
    computed: {
      searchData() {
        // 结算按钮跳转
        // 锁定加盟商
        const fromSettle = Boolean(this.$route.query.operatorId);
        return [
          {
            comName: 'YkcDropdown',
            key: 'operatorId',
            label: '加盟商名称',
            placeholder: '请选择加盟商名称',
            data: this.franchiseeData,
            remote: true,
            disabled: fromSettle,
          },
          {
            comName: 'YkcDropdown',
            key: 'stationId',
            label: '站点名称',
            placeholder: '请选择站点名称',
            remote: true,
            data: this.stationListData,
          },
          {
            comName: 'YkcDropdown',
            key: 'status',
            label: '状态',
            placeholder: '请选择状态',
            data: this.statusData,
          },
          {
            comName: 'YkcDatePicker',
            key: 'date',
            label: '创建时间',
            placeholder: '请选择创建时间',
          },
        ];
      },
    },
    // mounted() {
    //   this.requestList();
    // },
    watch: {
      $route: {
        handler(_, from) {
          if (from && from.path.includes('ApplyBy')) {
            this.requestList();
          }
        },
        deep: true,
        immediate: true,
      },
      // 加盟商变化时联动
      // 刷新电站与列表
      // 为空时查全部
      'searchParams.operatorId': 'handleOperatorIdChange',
    },
    created() {},
    mounted() {
      this.requestFranchiseeList();
      // 为空查全部加盟电站
      this.requestStationList(this.searchParams.operatorId);
      this.requestList();
      // this.initData();
    },
    methods: {
      /**
       * 加盟商变化时联动刷新电站与列表，为空时查全部
       */
      handleOperatorIdChange(val) {
        this.requestStationList(val);
        this.requestList();
      },
      /**
       * 初始数据
       */
      initData() {
        this.tableOperateButtons = [
          {
            enabled: () => code('finance:settle:franchisee:audit'),
            render: (h, data, { row }) =>
              row.status === 1 ? (
                <ykc-button
                  type="text"
                  onClick={() => {
                    this.id = row.id;
                    this.showAudit = true;
                  }}>
                  审批结算单
                </ykc-button>
              ) : null,
          },
          {
            enabled: () => code('finance:settle:franchisee:invoice'),
            render: (h, data, { row }) =>
              row.status === 2 ? (
                <ykc-button
                  type="text"
                  onClick={() => {
                    this.invoice(row.id);
                  }}>
                  确认发票
                </ykc-button>
              ) : null,
          },
          {
            enabled: () => code('finance:settle:franchisee:pay'),
            render: (h, data, { row }) =>
              row.status === 2 ? (
                <ykc-button
                  type="text"
                  onClick={() => {
                    this.payment(row.id);
                  }}>
                  确认收款
                </ykc-button>
              ) : null,
          },
          {
            enabled: () => true,
            render: (h, data, { row }) => (
              <ykc-button
                type="text"
                onClick={() => {
                  this.exportDetail(row);
                }}>
                导出订单明细
              </ykc-button>
            ),
          },
          {
            enabled: () => true,
            render: (h, data, { row }) => (
              <ykc-button
                type="text"
                onClick={() => {
                  this.toDetail(row.id);
                }}>
                详情
              </ykc-button>
            ),
          },
        ];
      },
      /**
       * 请求站点列表
       * @param {string|number} [operatorId] 加盟商ID，为空查全部加盟电站
       */
      requestStationList(operatorId) {
        franchiseeSettleManage
          .stationList(operatorId ? { operatorId } : {})
          .then(res => {
            this.stationListData = (res || []).map(item => {
              return {
                id: item.stationId,
                name: item.name,
              };
            });
          })
          .catch(err => {
            console.log(err);
          });
      },
      /**
       * 获取物业列表
       */
      requestFranchiseeList() {
        franchiseeSettleManage
          .franchiseeList({
            current: 1,
            size: 99999,
          })
          .then(res => {
            this.franchiseeData = (res || []).map(item => {
              return {
                id: item.operatorId,
                name: item.operatorName,
              };
            });
            // 仅当路由携带 operatorId 时（商户账户中心结算按钮跳转）选中对应加盟商
            // （watcher 会联动加载电站与列表）；其他情况不默认选中
            const routeOperatorId = this.$route.query.operatorId;
            const matched = this.franchiseeData.find(
              item => String(item.id) === String(routeOperatorId)
            );
            if (matched) {
              this.searchParams.operatorId = matched.id;
            }
          })
          .catch(err => {
            console.log(err);
          });
      },
      /**
       * 列表查询
       */
      requestList() {
        const reqParams = {
          ...this.searchParams,
          ...this.pageInfo,
        };
        franchiseeSettleManage
          .queryList(reqParams)
          .then(res => {
            this.tableData = res.records || [];
            this.pageInfo.total = res.total || 0;
          })
          .catch(err => {
            console.log(err);
          });
      },

      /**
       * 对账申请
       */
      apply() {
        this.stationForm.stationId = null;
        // 按选中加盟商带出
        // 为空查全部加盟电站
        this.requestStationList(this.searchParams.operatorId);
        this.showStationSelect = true;
      },
      /**
       * 站点选择
       */
      stationSelect() {
        this.$refs.stationForm.validate(valid => {
          if (valid) {
            const { stationId } = this.stationForm;
            this.showStationSelect = false;
            this.$router.push({
              // 系统结算
              path: '/financialManagement/settleManage/franchiseeSettlement/ApplyBySystem',
              query: {
                stationId,
              },
            });
            this.stationForm.stationId = null;
          }
        });
      },

      /**
       * 点击筛选查询按钮
       * */
      handleSearchConfirm(searchData) {
        this.pageInfo.current = 1;
        if (searchData.date && searchData.date.length) {
          [this.searchParams.startDate, this.searchParams.endDate] = searchData.date;
        }
        Object.assign(this.searchParams, searchData);

        this.requestList();
      },
      /**
       * 点击清空查询按钮
       * */
      handleSearchClean(form) {
        Object.assign(this.searchParams, form);
        // 跳转进入时锁定加盟商
        const routeOperatorId = this.$route.query.operatorId;
        if (routeOperatorId) {
          const matched = this.franchiseeData.find(
            item => String(item.id) === String(routeOperatorId)
          );
          if (matched) {
            this.searchParams.operatorId = matched.id;
          }
        }
      },
      /**
       *
       * */
      handlePaginationCurrentChange(current) {
        this.pageInfo.current = current;
        this.requestList();
      },
      /**
       *
       * */
      handlePaginationSizeChange(size) {
        this.pageInfo.current = 1;
        this.pageInfo.size = size;
        this.requestList();
      },
      /**
       * 取消操作
       */
      beforeCancel(drawerDone) {
        this.$dialog({
          dialogType: 'feedback',
          showTitle: false,
          closeOnClickModal: false,
          desc: '取消后操作将不被保存，确认是否取消？',
          onConfirm: done => {
            // 关闭弹框
            done();
            // 关闭抽屉
            drawerDone();
          },
        });
      },
      /**
       *
       * */
      onAddDrawerClose(done) {
        done();
      },

      toDetail(id) {
        this.$router.push({
          path: '/financialManagement/settleManage/franchiseeSettlement/Detail',
          query: {
            id,
          },
        });
      },
      /**
       * @desc 确认发票
       * */
      invoice(id) {
        YkcDialog({
          dialogType: 'feedback',
          showTitle: false,
          showFooter: true,
          desc: '是否确认发票？',
          onCancel: dialogDone => {
            dialogDone();
          },
          onConfirm: dialogDone => {
            franchiseeSettleManage.confirmInvoice({ id }).then(() => {
              this.$message({
                message: '提交成功',
                type: 'success',
              });

              this.requestList();
              dialogDone();
            });
          },
        });
      },
      /**
       * @desc 确认收款
       * */
      payment(id) {
        YkcDialog({
          dialogType: 'feedback',
          showTitle: false,
          showFooter: true,
          desc: '确认收款并发起提现？',
          onCancel: dialogDone => {
            dialogDone();
          },
          onConfirm: dialogDone => {
            franchiseeSettleManage.confirmPayment({ id }).then(() => {
              this.$message({
                message: '提交成功',
                type: 'success',
              });

              this.requestList();
              dialogDone();
            });
          },
        });
      },

      /**
       * @desc 导出订单明细
       * */
      exportDetail(row) {
        const { tradeTimeStart, tradeTimeEnd, stationId } = row;
        offlineExport({
          downloadType: 'finance_export',
          jsonNode: {
            downloadKey: 'franchiseeSettleExportMonthDetail',
            stationId,
            settleStartTime: tradeTimeStart,
            settleEndTime: tradeTimeEnd,
          },
        });
      },
      /**
       * @desc 审核结算单
       * */
      auditSettle(status) {
        this.$refs.auditForm.validate(valid => {
          if (valid) {
            if (status === 3) {
              this.$dialog({
                dialogType: 'feedback',
                showTitle: false,
                closeOnClickModal: false,
                desc: '确认审批通过？',
                onConfirm: done => {
                  const { auditRemark } = this.auditForm;
                  franchiseeSettleManage
                    .auditSettle({ id: this.id, status, auditRemark })
                    .then(() => {
                      this.$message({
                        message: '提交成功',
                        type: 'success',
                      });
                      this.auditForm.auditRemark = null;
                      this.requestList();
                      this.showAudit = false;
                    });
                  done(); // 关闭弹框
                },
              });
              return;
            }
            const { auditRemark } = this.auditForm;
            franchiseeSettleManage.auditSettle({ id: this.id, status, auditRemark }).then(() => {
              this.$message({
                message: '提交成功',
                type: 'success',
              });
              this.auditForm.auditRemark = null;
              this.requestList();
              this.showAudit = false;
            });
          }
        });
      },
    },
  };
</script>
<style lang="scss" scoped></style>
